import React, { Component } from 'react'
import {Platform, View, FlatList, StyleSheet} from 'react-native'
import { JDImage, JDDevice, JDTouchable, JDModal } from '@jdreact/jdreact-core-lib'
import {setWebHeaderTitle} from '../../utils/ut.web'
import styles from './styles'

import PageContainer from '../../components/PageContainer'
import FlatListFooter from '../../components/FlatListFooter'
import BrokerItem from "./components/BrokerItem"
import PropTypes from "prop-types";
import {imgProcess} from "../../utils/tools";
import {getDetailHouseData} from "../../utils/api";
import brokerCloseImg from '../../images/detail/close_img.png'

export default class BrokerInfo extends Component {
	static contextTypes = {
		router: PropTypes.object
	};
	constructor (props) {
		super(props);
		this.state = {
			requestParam: {
				pageNum: 0,
				pageSize: 40
			},
			statusData: {
				isListFetching: false,  // 正在加载数据
				error: null,            // 出错
				firstGet: true,          // 在第一次数据请求返回之前，不设置加载圈
				hasNext: true, // 是否还有数据
				isLastPage: false // 是否是最后一页
			},
			primaryKey: this.props.parmkey || "",
			brokerData: [], // 联系经纪人数据
			isShowBrokerInfoImg: false, // 是否展示经纪人信息卡图片
			postBrokerInfoImgUrl: null, // 经纪人信息卡图片的后缀网址
		}
	}
	componentDidMount () {
		if (Platform.OS === "web") {
			setWebHeaderTitle("经纪人列表");
		}
		this._onEndReached();
	}
	viewBrokerInfo = (postBrokerInfoImgUrl) => { // 展示经纪人大图
		this.setState({
			isShowBrokerInfoImg: true,
			postBrokerInfoImgUrl: postBrokerInfoImgUrl
		});
	};
	closeBrokerInfoImg = () => { // 关闭经纪人大图
		this.setState({
			isShowBrokerInfoImg: false
		});
	};
	_onEndReached = () => {
		let shouldFetch = true; // 是否请求数据
		this.setState((prevState) => {
			let {requestParam, statusData} = prevState;
			if (statusData.isListFetching) { // 若是正在加载数据，则不再向后端请求数据
				shouldFetch = false;
				return;
			}
			if (!statusData.hasNext || statusData.error != null) { // 若是到最后一页或后端数据请求失败
				return {
					...prevState,
					requestParam: {
						...requestParam,
						pageNum: prevState.requestParam.pageNum
					},
					statusData:{
						...statusData,
						isListFetching: true,
						error: null
					}
				}
			} else {
				return {
					...prevState,
					requestParam: {
						...requestParam,
						pageNum: prevState.requestParam.pageNum + 1
					},
					statusData:{
						...statusData,
						isListFetching: true,
						error: null
					}
				}
			}
		}, () => {
			if(shouldFetch && this.state.statusData.hasNext){
				this.fetchHouseDesData();
			}
		});
	}
	_renderBrokerItem = (brokerItemInfo, index) => {
		let brokerInfo = brokerItemInfo.item;
		return <View style={[brokerStyles.housebrokerListItem, brokerItemInfo.index === 0 && brokerStyles.housebrokerTop, brokerItemInfo.index === this.state.brokerData.length -1 && brokerStyles.housebrokerBottom]}>
			<BrokerItem isFooter={false} brokerInfo={brokerInfo} index={brokerItemInfo.index} viewBrokerInfo={this.viewBrokerInfo}></BrokerItem>
			</View>

	} // 渲染联系经纪人数据
	
	_renderFooter = ()  => {
		if(this.state.statusData.firstGet){
			return(<View></View>)
		}else {
			return null
			// return (
			// 		<FlatListFooter data={this.state.statusData}/>
			// )
		}
	};
	fetchHouseDesData = () => {
		let params = this.state.requestParam;
		let pageNum = params.pageNum;
		params.houseResourceId = this.props.parmkey || "" ;

		getDetailHouseData({primaryKey: this.props.parmkey}).then((res) => {
			if (res.code == 0) {
					let myData = res.brokerResult || {};
					let brokerData = myData.resourceBrokerDTOS || [];
					if (brokerData instanceof Array && brokerData.length > 0) {
						brokerData = this.state.brokerData.concat(brokerData);
					}
					this.setState({
						...this.state,
						statusData: {
							isListFetching: false,
							error: null,
							firstGet: false,
							isLastPage: true,
							hasNext: false
						},
						brokerData: brokerData
					});
			}
		}).catch(err => {
			this.setState({
				...this.state,
				statusData: {
					isListFetching: false,
					error: err,
					data: null,
					firstGet: false,
					hasNext: true
				}
			});
		});
	};
	render() {
		let {primaryKey, isShowBrokerInfoImg, postBrokerInfoImgUrl} = this.state;
		let imgDomainIndex = primaryKey % 7;
		return (
			<PageContainer title="经纪人列表" bodyStyle={brokerStyles.brokerContainer}>
						<JDModal visible={isShowBrokerInfoImg} transparent={true} onRequestClose={()=>{}}>
							<View style={styles.brokerInfoBox}>
								<JDTouchable onPress={this.closeBrokerInfoImg}>
									<View style={styles.brokerInfoCon}>
										<View>
											<JDImage
													style={styles.brokerInfoImg}
													source={{uri: imgProcess(postBrokerInfoImgUrl, "800x600", 60, imgDomainIndex)}}
											></JDImage>
										</View>
										<View style={styles.brokerInfoImgClose}>
											<JDImage
													style={styles.imgCloseIcon}
													source={brokerCloseImg}
											></JDImage>
										</View>
									</View>
								</JDTouchable>
							</View>
						</JDModal>
				<FlatList
					style={brokerStyles.housebrokerList}
					data={this.state.brokerData}
					renderItem={this._renderBrokerItem}
					ListFooterComponent={this._renderFooter}
					onEndReached={()=>{this._onEndReached()}}
					onEndReachedThreshold={0.5}
					keyExtractor={(item, index) => 'brokerData_'+index}
				/>
			</PageContainer>
		)
	}
}
const brokerStyles = StyleSheet.create({
	brokerContainer: {
		flex:1,
		backgroundColor: '#F6F6F6',
		// paddingTop: JDDevice.getRpx(30),
	},
	housebrokerList: {
		width: JDDevice.getRpx(702),
		marginLeft: JDDevice.getRpx(24),
		marginTop: JDDevice.getRpx(24),
	},
	housebrokerListItem: {
		width: JDDevice.getRpx(702),
		backgroundColor: '#ffffff',
		paddingHorizontal: JDDevice.getRpx(30),
	},
	housebrokerTop: {
		paddingTop: JDDevice.getRpx(30),
		borderTopLeftRadius: JDDevice.getRpx(24),
		borderTopRightRadius: JDDevice.getRpx(24),
	},
	housebrokerBottom: {
		paddingBottom: JDDevice.getRpx(24),
		borderBottomLeftRadius: JDDevice.getRpx(24),
		borderBottomRightRadius: JDDevice.getRpx(24),
	},
	rowLine: {
		width: JDDevice.getRpx(560),
		height: JDDevice.getDpx(1),
		backgroundColor: '#E3E5E9',
		marginLeft: JDDevice.getRpx(130),
		marginBottom: JDDevice.getRpx(35),
	} // 横线的样式

});
